import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { PROJECT_CATEGORY_API } from "./apiRoutes";

interface UseGetProjectCategoriesProps {
  tenantId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getProjectCategories = async (tenantId: string) => {
  return await axiosAuth.get(`${PROJECT_CATEGORY_API(tenantId)}`);
};

const useGetProjectCategories = ({
  tenantId,
  queryParams,
}: UseGetProjectCategoriesProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["project-categories"],
    queryFn: () => getProjectCategories(tenantId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetProjectCategories;
